<template>
  <div class="field_wrapper px_10 py_14 my_4 mt_22">
    <MultiselectDropdown
        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.TYPE.LABEL')"
        classNameLabel="llm_dropdown"
    >
        <multiselect
            class="column small-12"
            v-model="items.type"
            :options="bodyDataTypes"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="'Select'"
            track-by="value"
            label="label"
            :selectLabel="''"
            @select="onBodyDataTypeSelect"
        />
    </MultiselectDropdown>
    <!-- keep in constant_value for array item -->
    <InputField
        v-if="!['array','object'].includes(items.type.value)"
        v-model="items.constant_value"
        :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.CONSTANT_VALUE.LABEL')"
        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.CONSTANT_VALUE.PLACEHOLDER')"
        type="textarea"
        class="msg_textarea"
         :error="error && error.constant_value && error.constant_value._errors ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.CONSTANT_VALUE.ERROR') : ''"
    />
    <!-- <pre>{{items}}</pre> -->
    <!-- <div>Add items button if type === array | recursive call BodyArrayItem</div> -->
    <!-- <div>Add properties button if type === object | call BodyNestedProperty</div> -->
    <div v-if="items.type.value === 'object' && items.properties">
        <label>
            {{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.PROPERTIES.LABEL')}}
        </label>
        <div class="bg-light px_12 py_12" style="border-radius:8px;">
            <BodyNestedProprty
                v-for="(propertyEl,indexEl) in items.properties"
                :property="propertyEl"
                :bodyDataTypes="bodyDataTypes"
                :key="propertyEl.key || indexEl"
                :propertyValueTypes="propertyValueTypes"
                :variableList="variableList"
                :index="indexEl"
                :propertyList="items.properties"
                :agentVariables="agentVariables"
                :error="error && error.properties ? error.properties[indexEl] : {}"
            />
            <div class="add_body_property_btn py_20">
                <woot-button
                    variant="smooth"
                    color-scheme="primary"
                    size="small"
                    @click="addBodyProperty"
                >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.PROPERTIES.ADD_BUTTON')}}</woot-button>
            </div>
        </div>
    </div>

    <div v-if="items.type.value === 'array' && items.items">
            <!-- separate recursive item componnet -->
            <label>
                {{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.ITEM.LABEL')}}
            </label>
            <div class="bg-light px_12 py_12" style="border-radius:8px;">
                <BodyArrayItem
                    :items="items.items"
                    :bodyDataTypes="bodyDataTypes"
                    :propertyValueTypes="propertyValueTypes"
                    :agentVariables="agentVariables"
                    :error="error && error.items ? error.items : {}"
                />

            </div>
        </div>
  </div>
</template>

<script>
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import InputSlot from 'components/ui/inputs/MultiselectDropdown.vue'; // use as input slot
import InputField from 'components/ui/inputs/InputField.vue';
import InputCard from "components/ui/inputs/InputCard.vue";
import SliderRangeInput from "components/ui/inputs/SliderRangeInput.vue";
import CheckboxInput from "components/ui/inputs/CheckboxInput.vue";
// import BodyNestedProprty from './BodyNestedProprty.vue'

// import BodyNestedProprty from "dashboard/routes/dashboard/settings/campaigns/llm_chatbot/BodyNestedProprty.vue"

export default {
    name:"BodyArrayItem",
    components: {
        MultiselectDropdown,
        InputField,
        InputCard,
        SliderRangeInput,
        InputSlot,
        CheckboxInput,
        // BodyNestedProprty,
    },
    props:{
        items:{
            type: Object,
            default:()=>({})
        },
        bodyDataTypes:{
            type: Array,
            default: ()=>[],
        },
        propertyValueTypes:{
            type: Array,
            default: ()=>[],
        },
        variableList:{
            type: Array,
            default: ()=>[],
        },
        error: {
            type: Object,
            default: () => ({})
        },
        agentVariables:{
            type: Array,
            default: ()=>[],
        },
    },
    beforeCreate() {
    // Lazy-register BodyNestedProprty at runtime
        this.$options.components.BodyNestedProprty = require('./BodyNestedProprty.vue').default;
    },
    methods:{
        onBodyDataTypeSelect(item){
            this.$set(this.items, 'type', item); // Ensure type is also set reactively

            if (item.value === 'array') {
                this.$set(this.items, 'items', {
                    type: this.bodyDataTypes[3],
                    description: '',
                    constant_value: '',
                    dynamic_variable: { name: '', value: '' },
                });
                // Also remove properties if it was an object before
                this.$delete(this.items, 'properties');
            } else if (item.value === 'object') {
                this.$set(this.items, 'properties', [
                    {
                        id: '',
                        type: this.bodyDataTypes[3],
                        required: true,
                        description: '',
                        constant_value: '',
                        dynamic_variable: { name: '', value: '' },
                        value_type: this.propertyValueTypes[0],
                    },
                ]);
                this.$delete(this.items, 'items');
            } else {
                // Clean up if switching to a primitive type
                this.$delete(this.items, 'items');
                this.$delete(this.items, 'properties');
            }

            /*
            if (item.value === 'array') {
                // push or add items
                this.items.items={
                    type: this.bodyDataTypes[3],
                    description: "",
                    constant_value: "",
                    dynamic_variable: {name:"",value:""},
                }
            }else if (item.value === 'object') {
                // append properties
                this.items.properties = [
                    {
                        id:"",
                        type: this.bodyDataTypes[3],
                        required: true,
                        description: "",
                        constant_value: "",
                        dynamic_variable: {name:"",value:""},
                        value_type: this.propertyValueTypes[0],
                    },
                ];
            }
            */
        },
        addBodyProperty(){
            if (!Array.isArray(this.items.properties)) {
                this.$set(this.items, 'properties', []);
            }
            const newProperty = {
                key: Date.now(),
                id: "",
                type: this.bodyDataTypes[3],
                description: "",
                required: true,
                dynamic_variable: {name:"",value:""},
                constant_value: "",
                value_type: this.propertyValueTypes[0] || null,
            };

            this.items.properties.push(newProperty);

            // Force Vue to update via object reassignment (hacky, but reliable in Vue 2)
            this.$set(this.items, 'properties', [...this.items.properties]);
        },



    },
}
</script>

<style>

</style>